import { ControlConfig } from '../controlConfig';
import AddControlSelect from './AddControlSelect';
import ControlSelectEngine from './ControlSelectEngine';
import ControlSelectEntry from './ControlSelectEntry';
import ControlSelectPlaceholder from './ControlSelectPlaceholder';
import getLatestSchema from './schema';
import getDefaultValue from './getDefaultValue';
import getYupSchemaForSelectEngine from './getYupSchemaForSelectEngine';
import getYupSchemaForSelectEntry from './getYupSchemaForSelectEntry';
import translator from './translator';

export default {
  getDefaultValue,
  getLatestSchema,
  Engine: ControlSelectEngine,
  Entry: ControlSelectEntry,
  Add: AddControlSelect,
  yupSchemaEngine: getYupSchemaForSelectEngine,
  yupSchemaEntry: getYupSchemaForSelectEntry,
  translator,
  Placeholder: ControlSelectPlaceholder,
  previewCardHeight: '120px'
} as ControlConfig;
